export default __webpack_public_path__ + "static/media/img-o-n-i1-v3-footer.8163a827.png";